import { Component, OnInit, ViewChild } from '@angular/core';
import { EditorComponent } from '../../../base/editor/editor.component';
import { HistoryComponent } from '../../../fragments/history/history.component';
import { AppService } from '../../../../services/app.service';
import { GroupService } from '../../../../services/groups/group.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { GroupEnvelope } from '../../../../models/net/envelope/group-envelope';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { GroupPerson } from '../../../../models/data/app-core/group-person';
import { Group } from '../../../../models/data/app-core/group';
import { GroupDocument } from '../../../../models/net/envelope/documents/group-document';
import { MatTableDataSource } from '@angular/material/table';
import { Person } from '../../../../models/data/app-core/person';
import { AvatarPrimitive } from '../../../../models/app/avatar-primitive';
import { ChipSelectorComponent } from '../../../fragments/chip-selector/chip-selector.component';
import { OrganizationalUnitEnvelope } from '../../../../models/net/envelope/organizational-unit-envelope';
import { OrganizationalUnit } from '../../../../models/data/app-core/organizational-unit';
import { OrganizationalUnitDocument } from '../../../../models/net/envelope/documents/organizational-unit-document';
import { OrganizationalUnitGroup } from '../../../../models/data/app-core/organizational-unit-group';

@Component({
    selector: 'app-group',
    templateUrl: './group.component.html',
    styleUrls: ['./group.component.css', '../../../../app.component.css']
})

export class GroupComponent extends EditorComponent {

    public avatarUrl: string = "";
    public availablePersons: AvatarPrimitive[] = [];
    public dynamicClassNamePersonsSpan: string = "expanding-span-collapsed";
    public selectedPersonIds: number[] = [];
    public displayedGroupPersonColumns: string[] = ["Avatar", "FirstName", "LastName", "Delete"];
    public groupPersonsDatasource = new MatTableDataSource((this.itemEnvelope?.Document as GroupDocument).Persons);
    public availableOrganizationalUnits: AvatarPrimitive[] = [];
    public selectedOrganizationalUnitIds: number[] = [];

    @ViewChild("appHistory") appHistory!: HistoryComponent;
    @ViewChild("personSelector") personSelector!: ChipSelectorComponent;
    @ViewChild("organizationalUnitsChipSelector") organizationalUnitsChipSelector!: ChipSelectorComponent;

    public constructor(public override appService: AppService,
                       public override itemService: GroupService,
                       public override route: ActivatedRoute,
                       public override location: Location) {

        super(appService, itemService, route, location, "person", "persons");
    }

    public override handleEditMode = (): void => {

        this.appService.navigateTo("person/" + this.itemId.toString(), "");
    }

    public override initializeEnvelope = (envelope: GroupEnvelope | null): void => {

        super.initializeEnvelope(envelope);

        this.itemEnvelope = new GroupEnvelope(envelope);
        this.itemEnvelopeSnapshot = this.appService.cloneObject(this.itemEnvelope);

        this.avatarUrl = envelope?.Document.Item?.AvatarBlobPath == null ? this.appService.defaultImageUri : envelope.Document.Item.AvatarBlobPath;

        const availablePersons: AvatarPrimitive[] = (this.itemEnvelope as GroupEnvelope).PersonsPool.map((i: Person) => {
            let result = new AvatarPrimitive();
            result.Id = i.PersonId;
            result.Name = i.FirstName + " " + i.LastName;
            result.AvatarBlobPath = i.AvatarBlobPath;
            return result;
        });

        this.groupPersonsDatasource = new MatTableDataSource((this.itemEnvelope?.Document as GroupDocument).Persons);
        this.availablePersons = availablePersons;

        const availableOrganizationalUnits: AvatarPrimitive[] = (this.itemEnvelope as GroupEnvelope).OrganizationalUnitPool.map((i: OrganizationalUnit) => {
            let result = new AvatarPrimitive();
            result.Id = i.OrganizationalUnitId;
            result.Name = i.Name;
            result.AvatarBlobPath = this.appService.defaultImageUri;
            return result;
        });

        this.selectedOrganizationalUnitIds = (this.itemEnvelope?.Document as GroupDocument).OrganizationalUnits.map(i => i.OrganizationalUnitId);
        this.availableOrganizationalUnits = availableOrganizationalUnits;
    }

    public ngAfterViewInit(): void {

        this.personSelector.itemAdded.subscribe((item: AvatarPrimitive) => {

            this.selectedPersonIds.push(item.Id);
        });

        this.personSelector.itemRemoved.subscribe((item: AvatarPrimitive) => {

            this.selectedPersonIds = [];
        });

        this.organizationalUnitsChipSelector.itemAdded.subscribe((item: AvatarPrimitive) => {

            this.selectedOrganizationalUnitIds.push(item.Id);
            this.addOrganizationalUnitToGroup(item.Id);
        });

        this.organizationalUnitsChipSelector.itemRemoved.subscribe((item: AvatarPrimitive) => {

            this.selectedOrganizationalUnitIds = [];
            this.removeOrganizationalUnitFromGroup(item.Id);
        });
    }

    public addOrganizationalUnitToGroup = (organizationalUnitId: number): void => {

        const document: GroupDocument = (this.itemEnvelope?.Document as GroupDocument);
        var newOrganizationalUnitGroup: OrganizationalUnitGroup = new OrganizationalUnitGroup();

        newOrganizationalUnitGroup.GroupId = document.Item.GroupId;
        newOrganizationalUnitGroup.OrganizationalUnitId = organizationalUnitId;

        document.OrganizationalUnits.push(newOrganizationalUnitGroup);
    }

    public removeOrganizationalUnitFromGroup = (organizationalUnitId: number): void => {

        const document: GroupDocument = (this.itemEnvelope?.Document as GroupDocument);

        const itemIndex: number | undefined = document.OrganizationalUnits.map((i: OrganizationalUnitGroup) => i.OrganizationalUnitId).indexOf(organizationalUnitId, 0);

        if (itemIndex != undefined && itemIndex > -1) {

            document.OrganizationalUnits.splice(itemIndex, 1);
        }
    }

    public onTabChange(event: MatTabChangeEvent) {

        if (event.index == 1 && !this.isRevisionListLoaded) {

            this.appHistory.searchRevisions();
        }
    }

    public editAvatar = (): void => {

        this.appService.showPendingFeatureDialog();
    }

    public addPersonToGroup = (): void => {

        const newGroupPerson = new GroupPerson();

        if (this.dynamicClassNamePersonsSpan == "expanding-span-collapsed") {

            this.dynamicClassNamePersonsSpan = "expanding-span-expanded";

        } else {

            if (this.selectedPersonIds.length == 1) {

                newGroupPerson.GroupId = (this.itemEnvelope?.Document?.Item as Group).GroupId;
                newGroupPerson.PersonId = this.selectedPersonIds[0];

                (this.itemEnvelope?.Document as GroupDocument).Persons.push(newGroupPerson);
                this.groupPersonsDatasource = new MatTableDataSource((this.itemEnvelope?.Document as GroupDocument).Persons);

                this.dynamicClassNamePersonsSpan = "expanding-span-collapsed";
                this.personSelector.clear();
                this.selectedPersonIds = [];
            }
        }
    }

    public getPersonAvatarBlobPath = (personId: number): string | undefined => {

        let result: string | undefined = "";

        let person: Person | undefined = (this.itemEnvelope as GroupEnvelope)?.PersonsPool.find((i: Person) => i.PersonId == personId);

        if (person) {

            result = person.AvatarBlobPath;
        }

        return result;
    }

    public getPerson = (personId: number): Person | undefined => {

        let result: Person | undefined = (this.itemEnvelope as GroupEnvelope)?.PersonsPool.find((i: Person) => i.PersonId == personId);

        return result;
    }

    public deletePerson = (removedGroupPerson: GroupPerson): void => {

        var groupDocument: GroupDocument = this.itemEnvelope!.Document as GroupDocument;

        groupDocument.Persons = groupDocument.Persons.filter((i: GroupPerson) => i.GroupPersonId !== removedGroupPerson.GroupPersonId);

        this.groupPersonsDatasource = new MatTableDataSource((this.itemEnvelope?.Document as GroupDocument).Persons);
    }

    public cancelAddPersonToGroup = (): void => {

        this.dynamicClassNamePersonsSpan = "expanding-span-collapsed";
        this.personSelector.clear();
        this.selectedPersonIds = [];
    }
}
